import update from 'immutability-helper'
import clsx from 'clsx'
import React from 'react'
import {makeStyles} from 'external/material'
import Box from '@mui/material/Box'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'

const useStyles = makeStyles(multipleChoicePropertiesStyles)
 
export default function MultipleChoiceProperties ({context, question, updateProperties}) {

  const classes = useStyles()

  const {translate} = context
  const {properties = {}, answer = {}} = question
  const {choices = []} = answer

  const correctCount = choices.reduce((a,c) => a + (c.correct ? 1 : 0), 0)

  const singleOption = properties.singleOption

  function changeSingleOption (checked) {
    const singleOption = correctCount < 2 && !checked
    const command = {singleOption: {$set: singleOption}}
    const properties = update(question.properties, command)
    updateProperties && updateProperties({id: question.id, properties}, {properties: command})
  }

  function changeShuffle (checked) {
    const command = {shuffle: {$set: checked}}
    const properties = update(question.properties, command)
    updateProperties && updateProperties({id: question.id, properties}, {properties: command})
  }

  /*
  React.useEffect(() => {
    if (singleOption != properties.singleOption) {
      changeSingleOption(singleOption)
    }
  }, [singleOption])
  */

  return (
    <Box className={classes.root}>
        <FormControlLabel
          size="small"
          className={classes.singleOption}
          control={
            <Checkbox
              size="small"
              color="primary"
              checked={!singleOption} 
              onChange={e => changeSingleOption(e.target.checked)}
            />
          }
          label={translate('allow-multiple-selections')}
        />
        <FormControlLabel
          size="small"
          className={classes.shuffle}
          control={
            <Checkbox
              size="small"
              color="primary"
              checked={properties.shuffle == true}
              onChange={e => changeShuffle(e.target.checked)}
            />
          }
          label={translate('randomize-choices')}
        />
    </Box>
  )
}

function multipleChoicePropertiesStyles(theme) {

  const verticalCentering = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  }

  return {
    root: {
      display: 'flex',
      "& .filler" : {
        flexGrow: 1
      }
    },
    multipleSelection: {
      color: '#4c4f58'
    },
  }
}

